import './i18n';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import GA4 from '@/components/GA4';
import Home from '@/pages/Home';
import EventoDetail from '@/pages/EventoDetail';
import ZonaDetail from '@/pages/ZonaDetail';
import LocaleDetail from '@/pages/LocaleDetail';
import LocaliList from '@/pages/LocaliList';
import Collabora from '@/pages/Collabora';
import NotFound from '@/pages/NotFound';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminForgotPassword from '@/pages/admin/AdminForgotPassword';
import AdminResetPassword from '@/pages/admin/AdminResetPassword';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminLocali from '@/pages/admin/AdminLocali';
import AdminEventi from '@/pages/admin/AdminEventi';
import AdminEventoForm from '@/pages/admin/AdminEventoForm';
import AdminRevisione from '@/pages/admin/AdminRevisione';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminTeam from '@/pages/admin/AdminTeam';
import AdminNewsletter from '@/pages/admin/AdminNewsletter';
import AdminCollaborazioni from '@/pages/admin/AdminCollaborazioni';
import AdminTrafficStats from '@/pages/admin/AdminTrafficStats';
import AdminImportEvents from '@/pages/admin/AdminImportEvents';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GA4 />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/eventi/:slug" element={<EventoDetail />} />
          <Route path="/serate-roma-:zonaSlug" element={<ZonaDetail />} />
          <Route path="/locali" element={<LocaliList />} />
          <Route path="/locali/:slug" element={<LocaleDetail />} />
          <Route path="/collabora" element={<Collabora />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/locali" element={<AdminLocali />} />
          <Route path="/admin/eventi" element={<AdminEventi />} />
          <Route path="/admin/eventi/nuovo" element={<AdminEventoForm />} />
          <Route path="/admin/eventi/importa" element={<AdminImportEvents />} />
          <Route path="/admin/eventi/:id/modifica" element={<AdminEventoForm />} />
          <Route path="/admin/revisione" element={<AdminRevisione />} />
          <Route path="/admin/team" element={<AdminTeam />} />
          <Route path="/admin/newsletter" element={<AdminNewsletter />} />
          <Route path="/admin/collaborazioni" element={<AdminCollaborazioni />} />
          <Route path="/admin/traffico" element={<AdminTrafficStats />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster richColors theme="dark" position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
